import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DisclosureItem from './DisclosureItem';
import BluebookLinkButton from '../bluebook-link-button';

const Disclosure = ({ items, hasExpandAll, hasCollapseAll }) => {
  const [expandedItems, setExpandedItems] = useState([]);
  const handleToggle = (index) => {
    setExpandedItems((prevExpandedItems) => {
      const newExpandedItems = [...prevExpandedItems];
      newExpandedItems[index] = !newExpandedItems[index];

      return newExpandedItems;
    });
  };
  const handleExpandAll = () => {
    setExpandedItems(() => {
      const newExpandedItems = [];
      items.forEach((_, index) => {
        newExpandedItems[index] = true;
      });

      return newExpandedItems;
    });
  };

  const handleCollapseAll = () => {
    setExpandedItems(() => {
      const newExpandedItems = [];
      items.forEach((_, index) => {
        newExpandedItems[index] = false;
      });

      return newExpandedItems;
    });
  };

  return (
    <>
      <div className="flex bb-desktop:justify-end bb-mobile:justify-start">
        {hasExpandAll && (
          <BluebookLinkButton
            accessibility={{
              'aria-label': 'Expand All',
            }}
            onClick={handleExpandAll}
            className="!border-r !border-solid !border-bluebook-gray3"
          >
            Expand All
          </BluebookLinkButton>
        )}
        {hasCollapseAll && (
          <BluebookLinkButton
            accessibility={{
              'aria-label': 'Collapse All',
            }}
            onClick={handleCollapseAll}
          >
            Collapse All
          </BluebookLinkButton>
        )}
      </div>
      <dl className="mt-0">
        {items.map(({ title, description }, index) => (
          <DisclosureItem
            key={title}
            title={title}
            description={description}
            isExpanded={!!expandedItems[index]}
            toggle={() => handleToggle(index)}
          />
        ))}
      </dl>
    </>
  );
};

Disclosure.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
  ).isRequired,
  hasExpandAll: PropTypes.bool,
  hasCollapseAll: PropTypes.bool,
};

Disclosure.defaultProps = {
  hasExpandAll: true,
  hasCollapseAll: true,
};

export default Disclosure;
